import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('CoreMapboxMglMap', {
    ref: "twinMap",
    class: _vm.classObject,
    attrs: {
      "attributionControl": false,
      "interactive": _vm.interactiveMap
    },
    on: {
      "load": _vm.onMapLoaded,
      "moveend": _vm.processAnimationQueue
    }
  }, [!_vm.preview && !_vm.header && !_vm.favorite ? [!_vm.fullScreenMap ? _c('core-button', {
    staticClass: "ml-1",
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-expand-arrows"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('expand');
      }
    }
  }) : _c('core-button', {
    staticClass: "ml-1",
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-compress-arrows-alt"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close-expanded');
      }
    }
  })] : _vm._e(), !_vm.allowMultiCoordinates ? [_c('MglMarker', {
    key: _vm.dtwData.faIcon,
    attrs: {
      "coordinates": _vm.markerCoordinates,
      "color": _vm.markerColor,
      "draggable": false,
      "anchor": _vm.hasMapIconAttachment ? 'center' : _vm.hasMapMarkerIcon ? 'bottom-left' : 'bottom'
    }
  }, [_vm.hasMapIconAttachment || _vm.hasMapMarkerIcon ? _c('span', {
    attrs: {
      "slot": "marker"
    },
    slot: "marker"
  }, [_vm.hasMapIconAttachment ? [_c('div', {
    staticClass: "markerIcon",
    style: `background-image: url('${_vm.mapMarkerIconUrl(_vm.dtwData)}')`
  })] : _vm.hasMapMarkerIcon ? [_c(VIcon, {
    staticClass: "markerPin",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-" + _vm._s(_vm.dtwData.faIcon))]), !_vm.favorite ? _c('span', {
    staticClass: "markerPinTitle"
  }, [_vm._v(_vm._s(_vm.dtwTitle))]) : _vm._e()] : _vm._e()], 2) : _vm._e()])] : _vm._l(_vm.geoCoordinates, function (marker, index) {
    return _c('MglMarker', {
      key: `marker_${index}`,
      attrs: {
        "coordinates": marker.coordinates,
        "title": marker.title,
        "color": _vm.markerColor,
        "draggable": false,
        "anchor": _vm.hasMapIconAttachment && !_vm.header && !_vm.favorite ? 'center' : 'bottom'
      }
    }, [_vm.multiCoordinatesIcon ? _c('span', {
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_c(VIcon, {
      staticClass: "markerPin",
      attrs: {
        "color": _vm.color
      }
    }, [_vm._v("fal fa-" + _vm._s(_vm.multiCoordinatesIcon))])], 1) : _vm._e(), _c('MglPopup', {
      attrs: {
        "anchor": "top"
      }
    }, [_c(VCard, {
      staticClass: "popup-box"
    }, [_c('div', {
      staticClass: "popup-box",
      domProps: {
        "innerHTML": _vm._s(marker.message)
      }
    })])], 1)], 1);
  }), _vm.interactiveMap ? _c('div', [_c('MglNavigationControl', {
    attrs: {
      "position": "bottom-right"
    }
  }), _c('MglGeolocateControl', {
    attrs: {
      "position": "bottom-right"
    }
  })], 1) : _vm._e()], 2), !_vm.preview && _vm.spectrum ? _c('div', {
    staticClass: "bottom-spectrum"
  }) : _vm._e(), _vm.preview && _vm.spectrum ? _c('div', {
    staticClass: "bottom-spectrum-preview"
  }) : _vm._e(), _vm.spectrum ? _c('h3', {
    staticClass: "ml-4 pl-3 pr-3 mt-8 dtwin-title-frame header-frame text-truncate"
  }, [_vm.hasMapMarkerIcon ? _c(VIcon, {
    class: _vm.color + '--text headline-icon',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.dtwData.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.dtwTitle) + "\n  ")], 1) : _vm._e(), !_vm.spectrum ? _c('h4', {
    staticClass: "dtwin-title-frame-fav"
  }, [_c('div', {
    staticClass: "mr-2 ml-2 pl-2 pr-1 text-truncate header-frame"
  }, [_vm._v(_vm._s(_vm.dtwTitle))])]) : _vm._e(), !_vm.spectrum ? _c('div', {
    staticClass: "text-caption dtwin-subtitle-frame-fav"
  }, [_c('div', {
    staticClass: "mr-2 ml-2 pl-2 pr-1 mt-6 text-truncate header-frame"
  }, [_vm._v("\n      " + _vm._s(_vm.subTitle) + "\n    ")])]) : _vm._e(), _vm.spectrum ? _c('div', {
    staticClass: "ml-4 pl-3 pr-3 mt-6 dtwin-subtitle-frame header-frame text-truncate"
  }, [_vm._v("\n    " + _vm._s(_vm.subTitle) + "\n  ")]) : _vm._e(), _vm._t("deviceTemplateLink")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };